// @flow
import HomeRouter from './HomeRouter'

export default HomeRouter
